import React from 'react';
import Pro01 from "../../images/services/bd/Digital-Transformation.webp"
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="why Choose">
                            <h2>Seasoned Tech Leaders</h2>
                        </div>
                        <p>Your Partners in Digital Transformation Working with TekRevol means getting seasoned
                            professionals and industry leaders for your digital products. That’s because we deliver
                            business value with the most cutting-edge technologies in the market. From AI to deep
                            learning to cloud-native solutions, we have empowered our clients and their communities,
                            corporates, and consumers.</p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">55+<span>Applications Delivered</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">34+<span>Businesses Transformed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">11+<span>Industries Served</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;